import axios from './axios.service';
import config from './../config';
import { getQueryStringFromObject, getRequestHeaders } from './common.service';

const getContacts = async (query=null) => {
    try {
      let queryString = '';
      if (query) {
          queryString = '?' + getQueryStringFromObject(query);
      }
      let response;
      try {
          let headers = getRequestHeaders();
          response = await axios.get( config.SERVER_BASE_URL + '/contacts' + queryString, { headers: headers });
      } catch (error) {
          return error.response.data;
      }
      return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getContact = async (contactId) => {
    try {
        let response;
        try {
            response = await axios.get( config.SERVER_BASE_URL + '/contacts/' + contactId, {
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const updateContact = async (id, payload) => {
    try {
        let response;
        try {
            response = await axios.patch( config.SERVER_BASE_URL + '/contacts/' + id, payload, {
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

export {
    getContacts,
    getContact,
    updateContact
}
